import React from "react";

export default function Dimensions({ dimensions = [] }) {
  return dimensions.map(field => [field.width, field.depth, field.height].join("x")).join(", ");
}
